<main class="main">
    <!-- CRMSP-7485 - Empleados VO -->
    <div class="spinner-overlay" *ngIf="spinner">
        <div class="spinner-border" role="status" aria-label="Cargando"></div>
    </div>
    <header class="main--header">
        <img class="main--header__logo" src="../../../assets/logos/seat-cupra-logo-white.svg"
            alt="{{ 'altLogo' | i18next }}" />
    </header>

    <section class="register">

        <!-- FORMULARIO -->
        <ng-container *ngIf="!accessRequestSuccess">

            <h2 class="title">
                {{
                requestType === 'ACCESS_REQUEST'
                ? ('accessRequestForm' | i18next)
                : ('userCreationRequest' | i18next)
                }}
            </h2>

            <form [formGroup]="registerForm" class="form">

                <!-- PASO 1: VALIDACIÓN DEL CÓDIGO -->
                <ng-container *ngIf="!codeValidated">

                    <mat-form-field>
                        <mat-label>
                            {{ 'validationCode' | i18next }}
                        </mat-label>

                        <input matInput formControlName="validationCode" #autofocus />
                    </mat-form-field>

                    <div class="btn-container">
                        <button mat-button type="button" class="btn-container--btnCancel" [routerLink]="['/login']">
                            {{ 'btnCancel' | i18next | uppercase }}
                        </button>

                        <button mat-button type="button" class="btn-container--btn" (click)="validateCode()" [disabled]="
                                registerForm.get('validationCode')?.invalid
                                || spinner
                            ">
                            {{ 'validate' | i18next | uppercase }}
                        </button>
                    </div>
                    <div>
                        <app-error-with-guide *ngIf="errorMessage" class="error-message" [message]="errorMessage">
                        </app-error-with-guide>
                    </div>
                </ng-container>

                <!-- PASO 2: FORMULARIO -->
                <ng-container *ngIf="codeValidated">

                    <mat-form-field>
                        <mat-label>
                            {{ 'requestType' | i18next }}
                        </mat-label>

                        <mat-select formControlName="requestType" (selectionChange)="changeRequestType($event.value)">
                            <mat-option value="ACCESS_REQUEST">
                                {{ 'accessRequestForm' | i18next }}
                            </mat-option>

                            <mat-option value="USER_CREATION">
                                {{ 'userCreationRequest' | i18next }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <!-- DNI/NIE -->
                    <mat-form-field>
                        <mat-label>
                            {{ 'nif' | i18next }}
                        </mat-label>

                        <input matInput formControlName="nis" minlength="9" maxlength="9" />
                    </mat-form-field>

                    <!-- FORMULARIO DE SOLICITUD DE ACCESO -->
                    <ng-container *ngIf="requestType === 'ACCESS_REQUEST'">
                        <mat-form-field>
                            <mat-label>
                                {{ 'email' | i18next }}
                            </mat-label>

                            <input matInput type="email" formControlName="email" />
                        </mat-form-field>

                        <div class="register-row">
                            <mat-form-field>
                                <mat-label>
                                    {{ 'name' | i18next }}
                                </mat-label>

                                <input matInput formControlName="name" />
                            </mat-form-field>

                            <mat-form-field>
                                <mat-label>
                                    {{ 'surnames' | i18next }}
                                </mat-label>

                                <input matInput formControlName="surname" />
                            </mat-form-field>
                        </div>

                        <mat-form-field>
                            <mat-label>
                                {{ 'phone' | i18next }}
                            </mat-label>

                            <input matInput formControlName="phone" minlength="9" maxlength="9" />
                        </mat-form-field>
                    </ng-container>

                    <!-- CREACIÓN DE USUARIO -->
                    <ng-container *ngIf="requestType === 'USER_CREATION'">
                        <mat-form-field>
                            <mat-label>
                                {{ 'password' | i18next }}
                            </mat-label>

                            <input matInput type="password" formControlName="password" />
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>
                                {{ 'repeatPassword' | i18next }}
                            </mat-label>

                            <input matInput type="password" formControlName="repeatPassword" />
                        </mat-form-field>

                        <p [ngClass]="errorMsg('repeatPassword')" class="error-text text">
                            {{ 'passwordPattern' | i18next }}
                        </p>
                    </ng-container>

                    <div class="btn-container">
                        <button mat-button type="button" class="btn-container--btnCancel" [routerLink]="['/login']">
                            {{ 'btnCancel' | i18next | uppercase }}
                        </button>

                        <button mat-button type="button" class="btn-container--btn" (click)="onSubmit()"
                            [disabled]="!registerForm.valid || spinner">
                            {{ 'btnAccept' | i18next | uppercase }}
                        </button>
                    </div>
                    <div>
                        <app-error-with-guide *ngIf="errorMessage" class="error-message" [message]="errorMessage">
                        </app-error-with-guide>
                    </div>
                </ng-container>
            </form>
        </ng-container>

        <!-- SOLICITUD REALIZADA CORRECTAMENTE -->
        <ng-container *ngIf="accessRequestSuccess">

            <h2 class="title">
                {{ 'accessRequestSuccessTitle' | i18next }}
            </h2>

            <div class="form">
                <p class="text">
                    {{ 'accessRequestSuccessMessage' | i18next }}
                </p>

                <div class="btn-container">
                    <button mat-button type="button" class="btn-container--btn" [routerLink]="['/login']">
                        {{ 'backToLogin' | i18next | uppercase }}
                    </button>
                </div>
            </div>
        </ng-container>
    </section>
</main>